import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { ATTACHMENT_API } from "./apiRoutes";

interface mutateProps {
  data: any;
}

const mutateAddAttachmentWithEntity = async ({
  data,
}: mutateProps) => {
  const entityType = data.entityType;
  const entityId = data.entityId;
  const fileDescription = data.fileDescription;

  delete data[entityType];
  delete data[entityId];
  delete data[fileDescription];

  return await axiosAuth.post(
    `${ATTACHMENT_API}?entityType=${entityType}&entityId=${entityId}${fileDescription ? '&fileDescription=' + fileDescription : ''}`,
    {file: data.file},
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useAddAttachmentWithEntityMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddAttachmentWithEntity,
    ...queryParams,
  });

export default useAddAttachmentWithEntityMutation;
